import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ProductSlider/productSlider.default"
    ).then((module) => ({
        default: module.ProductSliderDefault
    }))
);
